import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, Subject, catchError, debounceTime, distinctUntilChanged, of, switchMap, tap } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ProductDetailsService } from 'src/app/services/product-details.service';

@Component({
  selector: 'app-products-attributes-dropdown',
  templateUrl: './attributes-dropdown.component.html',
  styleUrls: ['./attributes-dropdown.component.scss']
})
export class ProductsAttributesDropdownComponent implements OnInit {
  @Input() categoryIds!: string;
  @Output() additionalAttributesChanged = new EventEmitter<string>();

  attributes!: Observable<string[]>;
  searching: boolean = false;
  selectedAttributes: string[] = [];
  searchSubject = new Subject<string>();

  allAttributesAsColumns: boolean = false;

  constructor(
    private productDetailsService: ProductDetailsService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.attributes = this.searchSubject.pipe(
      distinctUntilChanged(),
      debounceTime(800),
      tap(() => this.searching = true),
      switchMap(searchString => {
        if (searchString && searchString.trim() !== '') {
          return this.productDetailsService.getAdditionalAttributes(this.categoryIds, searchString, 20).pipe(
            tap(() => this.searching = false),
            catchError(error => {
              console.error('Attributes Search Error:', error);
              this.toastr.error('Something went wrong with searching attributes, try searching again.');
              return of([]);
            })
          );
        } else {
          return of([]).pipe(
            tap(() => this.searching = false)
          );
        }
      })
    );
  }

  emitData() {
    this.additionalAttributesChanged.emit([...this.selectedAttributes].join('|'));
  }
}
